import React, { Component, createRef } from "react";
import styled from "styled-components";
import Grade from "grade-js";

import { playAll } from "./actions";
import Options from "./playlist-menu";
import { Text, Col, Row, Img, Gap, FXontIcon } from "../../../comps";
import MaterialButton from "@material-ui/core/Button";
import MaterialIconButton from "@material-ui/core/IconButton";
import MaterialButtonGroup from "@material-ui/core/ButtonGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";

import { defaultVideoArt } from "../../../theme/image";
import { faPlay, faStream, faTh } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
`;

const Content = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* min-height: 240px; */
  align-items: center;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
    flex-direction: column;
  }
  overflow: hidden;
`;

const PlaylistThumbnail = styled(Img)`
  border-radius: 10px;
  margin-left: 10px;
`;

const Details = styled(Col)`
  margin-left: 3%;
  height: 180px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    margin-top: 20px;
    width: 100%;
  }
`;
const Nav = styled(Col)`
  position: absolute;
  bottom: 0px;
  right: 20px;
`;

const ButtonGroup = styled(MaterialButtonGroup)`
  height: 40px;
  margin-top: auto;
  margin-bottom: 10px;
`;

export default class extends Component {
  constructor() {
    super();
    this.refThumbnail = createRef();
    this.state = {};
  }

  setViewAsGrid = () => {
    const { currentView, VIEW_TYPES, setView } = this.props;
    const isGridView = currentView === VIEW_TYPES.MIXED_GRID;
    if (!isGridView) setView(VIEW_TYPES.MIXED_GRID);
  };

  setViewAsList = () => {
    const { currentView, VIEW_TYPES, setView } = this.props;
    const isListView = currentView === VIEW_TYPES.LIST;
    if (!isListView) setView(VIEW_TYPES.LIST);
  };

  onImgLoad = () => {
    console.log("image loded");
    Grade(document.querySelectorAll(".hellograde"));
    Grade(document.querySelectorAll(".hellograde"), null, function (
      gradientData
    ) {
      console.log("data found from Grade js", gradientData);
    });
  };

  render() {
    const { playlist, currentView, VIEW_TYPES, setView, refresh } = this.props;
    const { name, thumbnail, totalSongs, ownerUsername, songs } = playlist;
    const isListView = currentView === VIEW_TYPES.LIST;
    const isGridView = currentView === VIEW_TYPES.MIXED_GRID;
    const ratio = 20;

    return (
      <Wrapper>
        <Content className={"hellograde"}>
          <PlaylistThumbnail
            width={ratio * 16}
            height={ratio * 9}
            src={thumbnail || defaultVideoArt}
          />
          <Details>
            <Text color={`#d7e0da`} fontWeight={600} fontSize={"30px"}>
              {name}
            </Text>
            <Text
              color={Theme.color.WHITE_1}
              marginTop={`8px`}
              fontWeight={400}
              fontSize={"18px"}
            >{`by ${ownerUsername || "AVC"}`}</Text>
            <Row marginTop={`20px`}>
              <Text
                color={Theme.color.WHITE_1}
                fontWeight={400}
                fontSize={"14px"}
              >{`Tracks : `}</Text>
              <Text color={`#d7e0da`} fontWeight={400} fontSize={"14px"}>
                {totalSongs}
              </Text>
            </Row>
            <Row marginTop={`auto`} alignItems={`center`}>
              <MaterialButton
                style={{
                  borderRadius: 50,
                  backgroundColor: Theme.color.BLUE_5,
                }}
                variant="contained"
                color="secondary"
                startIcon={<FontAwesomeIcon icon={faPlay} />}
                onClick={() => {
                  playAll(songs);
                }}
              >
                Play All
              </MaterialButton>
              <Gap width={20} />
              <Options refresh={refresh} playlist={playlist} />
            </Row>
          </Details>
        </Content>
        <Nav>
          <ButtonGroup
            variant="text"
            color="primary"
            aria-label="text primary button group"
          >
            <MaterialIconButton onClick={this.setViewAsGrid}>
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: Theme.color[isGridView ? `BLUE_4` : `BLUE_2`],
                }}
                icon={faTh}
              />
            </MaterialIconButton>
            <MaterialIconButton onClick={this.setViewAsList}>
              <FontAwesomeIcon
                style={{
                  fontSize: "22px",
                  color: Theme.color[isGridView ? `BLUE_4` : `BLUE_2`],
                }}
                icon={faStream}
              />
            </MaterialIconButton>
          </ButtonGroup>
        </Nav>
      </Wrapper>
    );
  }
}
